import { DropdownMenu, Flex, IconButton, Text, Spinner } from '@radix-ui/themes'
import { DotsVerticalIcon, GearIcon } from '@radix-ui/react-icons'
import { LuChartArea, LuDownload, LuFileSpreadsheet } from 'react-icons/lu'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

interface ExportDropdownMenuProps {
  handleExportCSV: () => void
  handleExportImage: () => Promise<void>
  isExporting?: boolean
  linkTo?: string
  linkParams?: Record<string, any>
  linkText?: string
}

export function ChartSectionMoreOptionsMenu({
  handleExportCSV,
  handleExportImage,
  isExporting = false,
  linkTo,
  linkParams,
  linkText
}: ExportDropdownMenuProps) {
  const { t } = useTranslation(['common'])

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <IconButton variant="outline" color="gray" size="2" aria-label="more-options">
          <DotsVerticalIcon />
        </IconButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content variant="soft">
        <DropdownMenu.Sub>
          <DropdownMenu.SubTrigger>
            <Flex align={'center'} gap={'2'}>
              <LuDownload />
              <Text>{t('export')}</Text>
            </Flex>
          </DropdownMenu.SubTrigger>
          <DropdownMenu.SubContent>
            {isExporting ? (
              <Flex align="center" justify={'center'} p="2">
                <Spinner size="1" />
              </Flex>
            ) : (
              <>
                <DropdownMenu.Item
                  onClick={handleExportCSV}
                  disabled={isExporting}
                  className="flex items-center gap-2"
                >
                  <LuFileSpreadsheet size={16} />
                  <Text>{t('exportCSV')}</Text>
                </DropdownMenu.Item>
                <DropdownMenu.Item onClick={handleExportImage} disabled={isExporting}>
                  <Flex align="center" gap="2">
                    {isExporting ? <Spinner size="1" /> : <LuChartArea size={16} />}
                    <Text>{isExporting ? t('exporting') : t('exportImage')}</Text>
                  </Flex>
                </DropdownMenu.Item>
              </>
            )}
          </DropdownMenu.SubContent>
        </DropdownMenu.Sub>
        {linkTo && linkParams && linkText && (
          <DropdownMenu.Item>
            <Link to={linkTo} params={linkParams} className="flex items-center gap-2 w-full">
              <GearIcon />
              <Text as="span">{linkText}</Text>
            </Link>
          </DropdownMenu.Item>
        )}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  )
}
